import { render } from "./ThreeDCharacter.vue?vue&type=template&id=4682fd6c&scoped=true"
import script from "./ThreeDCharacter.vue?vue&type=script&lang=js"
export * from "./ThreeDCharacter.vue?vue&type=script&lang=js"

import "./ThreeDCharacter.vue?vue&type=style&index=0&id=4682fd6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4682fd6c"]])

export default __exports__